import { render } from "./MahjView.vue?vue&type=template&id=7bf3507d&scoped=true"
import script from "./MahjView.vue?vue&type=script&lang=js"
export * from "./MahjView.vue?vue&type=script&lang=js"

import "./MahjView.vue?vue&type=style&index=0&id=7bf3507d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf3507d"]])

export default __exports__